// ** React Imports
import { useEffect } from 'react'

// ** Mui Imports
import { Box, Container, IconButton, SxProps, Typography } from '@mui/material'

// ** Icon Imports
import Icon from 'src/@core/components/icon'

// ** Effector Imports
import { useStore } from 'effector-react'

// ** Modules Imports
import { useIntl } from 'react-intl'
import { useFlag } from '@unleash/proxy-client-react'

// ** Source code Imports
import globalStore, { changeModalRegistrationStatus, closeModalRegistrationClosed } from 'src/state-manager/global'

interface IProps {
  sx?: SxProps
}

const RegistrationClosed = ({ sx }: IProps) => {
  const { formatMessage } = useIntl()

  const registration_closed = useFlag('registration_closed')

  const { open } = useStore(globalStore.modalRegistrationClosed)

  useEffect(() => {
    changeModalRegistrationStatus(registration_closed)
  }, [registration_closed])

  const onClose = () => {
    closeModalRegistrationClosed()
  }

  if (!open) return null

  return (
    <Box
      sx={{
        backgroundColor: theme => theme.palette.warning.dark,
        width: '100%',
        padding: '15px 0',
        ...sx
      }}
    >
      <Container
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          '&.MuiContainer-root': { maxWidth: '1200px', padding: '0 0.75rem' }
        }}
      >
        <Box
          sx={{
            maxWidth: '850px',
            fontSize: '14px',
            lineHeight: '20px',
            color: '#fff',
            '@media (max-width:1024px)': {
              maxWidth: '720px'
            },
            '@media (max-width:768px)': {
              fontSize: '12px',
              mb: '16px'
            }
          }}
        >
          <Typography variant='body2' sx={{ color: theme => theme.palette.common.white }}>
            {formatMessage({ id: 'registration-clossed-warning' })}
          </Typography>
        </Box>
        <IconButton
          sx={{
            color: theme => theme.palette.common.white
          }}
          onClick={onClose}
        >
          <Icon icon='mdi:close' />
        </IconButton>
      </Container>
    </Box>
  )
}

export default RegistrationClosed
